// Copied from platform-app components/pos/customerFacing/defaults.ts on 2026-10-14 for Super Admin → POS Defaults — keep in step with the original.
import type { APosCustomerDisplayConfig } from '@platform/shared-types';
export function defaultCustomerDisplayConfig(): APosCustomerDisplayConfig {
  return {
    // Match till (follow the cashier's POS Theme) with the RubyTill Ruby accent.
    theme: 'light', accentColor: '#DC143C', followCashierTheme: true,
    effect: 'none',
    idle: { logoUrl: null, logoFit: 'contain' as const, storeName: '', tagline: '', mode: 'static', playlistId: null },
    promo: { enabled: false, text: '', imageUrl: null, placement: 'both' },
    qr: { enabled: false, target: 'loyalty', position: 'top-right' },
    thankYou: { message: '', showLogo: true, visual: 'animation', animation: 'heart', imageUrl: null },
  };
}
